
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useFavorites } from "@/hooks/useFavorites";
import { useLanguage } from "@/hooks/useLanguage";

const FavoritesSection = () => {
  const navigate = useNavigate();
  const { favorites } = useFavorites();
  const { t } = useLanguage();

  return (
    <Card className="bg-gray-900/80 border-gray-600">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-ice-white">
          <Heart className="w-5 h-5 text-pink-500" />
          {t('favorites') || 'Favorites'}
        </CardTitle>
        <CardDescription className="text-gray-300">
          View and manage your favorite profiles
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div className="text-sm text-gray-400">
            You have {favorites.length} favorite profile{favorites.length !== 1 ? 's' : ''}
          </div>
          <Button 
            variant="outline" 
            onClick={() => navigate('/favorites')}
            className="text-sm"
          >
            <Heart className="w-4 h-4 mr-2" />
            View Favorites
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default FavoritesSection;
